import { render, staticRenderFns } from "./AgentAccessTokens.vue?vue&type=template&id=beba6c2a"
import script from "./AgentAccessTokens.vue?vue&type=script&lang=js"
export * from "./AgentAccessTokens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports